import { NotificationsRes, Type } from '@/api/types/notificationsType';

const REQUEST_REVIEW_TYPES: Type[] = [
  Type.REQUEST_SUBMISSION,
  Type.REQUEST_ASSIGNED,
  Type.REQUEST_APPROVAL,
  Type.REQUEST_REJECTED,
  Type.CHANGE_REQUEST,
  Type.CHANGE_REQUEST_RESOLVED,
];

const ADMIN_TYPES: Type[] = [
  Type.ADMIN_CREATED,
  Type.ADMIN_UPDATED,
  Type.ROLE_ASSIGNED,
  Type.ROLE_PERMISSION_ASSIGNED,
];

const USER_MANAGEMENT_TYPES: Type[] = [Type.USER_CREATED, Type.USER_DISABLED];

export type NotificationAction =
  | { kind: 'navigate'; route: string }
  | { kind: 'review-registration'; requestId: number }
  | { kind: 'none' };

const getSystemAdminRoute = (notification: NotificationsRes): string | null => {
  const { type, post_id, params } = notification;

  if (REQUEST_REVIEW_TYPES.includes(type) && params?.request_id && post_id) {
    return `/listing-request/showPostReq/${post_id}/${params.request_id}`;
  }

  if (type === Type.POST_PUBLICATION && post_id) {
    return `/posts/${post_id}`;
  }

  return null;
};

export const getNotificationRoute = (
  notification: NotificationsRes,
  adminType?: string
): string | null => {
  if (adminType === 'SYSTEM_ADMIN') {
    return getSystemAdminRoute(notification);
  }

  const { type, post_id, params } = notification;

  if (REQUEST_REVIEW_TYPES.includes(type) && params?.request_id) {
    if (post_id) {
      return `/listing-request/showPostReq/${post_id}/${params.request_id}`;
    }

    return '/listing-request';
  }

  if (type === Type.UserRegistration && params?.user_id) {
    return `/${params.user_id}`;
  }

  if (USER_MANAGEMENT_TYPES.includes(type)) {
    if (params?.user_id) {
      return `/${params.user_id}`;
    }

    return '/';
  }

  if (type === Type.POST_PUBLICATION && post_id) {
    return `/posts/${post_id}`;
  }

  if (ADMIN_TYPES.includes(type)) {
    return '/admins';
  }

  return null;
};

export const getNotificationAction = (
  notification: NotificationsRes,
  adminType?: string
): NotificationAction => {
  if (
    notification.type === Type.UserRegistration &&
    notification.params?.request_id
  ) {
    return {
      kind: 'review-registration',
      requestId: notification.params.request_id,
    };
  }

  const route = getNotificationRoute(notification, adminType);

  if (route) {
    return { kind: 'navigate', route };
  }

  return { kind: 'none' };
};

export const isNotificationNavigable = (
  notification: NotificationsRes,
  adminType?: string
): boolean => getNotificationAction(notification, adminType).kind !== 'none';
